'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/municipalities/:municipalityId', null, {
            getAll: {method: 'GET'},
            get: {method: 'GET'},
            create: {method: 'POST'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            enable: {url: 'api/municipalities/:municipalityId/enable', method: 'PUT'},
            delete: {url: 'api/municipalities/:municipalityId/delete', method: 'PUT'},
            getDefault: {url: 'api/municipalities/default', method: 'GET'},
            setDefault: {url: 'api/municipalities/:municipalityId/default', method: 'PUT'},
            isUniqueName: {url: 'api/municipalities/unique/name/:name', method: 'GET'}
        });
    }];